import { render, staticRenderFns } from "./CommunityWizard.vue?vue&type=template&id=3d963f4f&scoped=true"
import script from "./CommunityWizard.vue?vue&type=script&lang=js"
export * from "./CommunityWizard.vue?vue&type=script&lang=js"
import style0 from "./CommunityWizard.vue?vue&type=style&index=0&id=3d963f4f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d963f4f",
  null
  
)

export default component.exports